<template>
    <div class="order-book-builds">
        <BooksBuilds
            v-if="book.id"
            :book-id="book.id"
            :permissions="order.permissions"
            :builders="builders"
            :store="{ book }"
            combine-builders
        >
            <template #trigger="{ start }">
                <button
                    type="button"
                    class="button button--outlined button--fullwidth button--medium"
                    @click.prevent="start"
                >
                    Download files
                </button>
            </template>
        </BooksBuilds>
    </div>
</template>

<script>
import { BooksBuilds } from '@speechki-frontend/core/editor/components';
import { BUILDERS } from './utils';

export default {
    name: 'OrderBookBuilds',
    components: {
        BooksBuilds,
    },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            builders: BUILDERS,
        };
    },
    computed: {
        book() {
            const { book_id: id } = this.order;
            return { id };
        },
    },
};
</script>
